// extracted by mini-css-extract-plugin
export default {"FInput_Search":"FInput_Search___x4Btv","InputError":"InputError___udyd6","darkPrefix":"darkPrefix___hisVy"};